import { render } from "./App.vue?vue&type=template&id=2b1cc86c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2b1cc86c&lang=css"

import exportComponent from "D:\\Doc\\e\\单子\\工作室的单\\018 杰优宝协议看视频\\CollectVideoV2\\Client\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__